import styles from './Tab.module.scss';

import { useHapticFeedback } from '@/hooks/useHapticFeedback';
import { useNavigation } from '@/hooks/useNavigation';
import { PAGE, RouteConfigItem } from '@/modules/page/routes';
import { useStore } from '@/store';
import { analytics } from '@/utils/analytics';
import { HELIKA_EVENT_TYPE } from '@/utils/helika';
import cn from 'classnames';

import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

export const Tab = observer(({ tab }: { tab: RouteConfigItem }) => {
  const { currentPage, goTo } = useNavigation();
  const { t } = useTranslation();

  const {
    accountStore: { accountData },
  } = useStore();

  const { triggerHapticFeedback } = useHapticFeedback();

  const handleSetPage = () => {
    triggerHapticFeedback('medium');

    if (tab.path === PAGE.PROFILE_ID) {
      analytics.sendEvent({
        event_type: HELIKA_EVENT_TYPE.UI,
        event: {
          event_sub_type: 'tab_profile_click',
          event_details: {
            event_label: 'App profile tab click',
            event_action: 'click',
          },
        },
      });
      goTo(tab.path, { id: accountData._id || 'me' });
      return;
    }

    if (tab.path === PAGE.TASKS) {
      analytics.sendEvent({
        event_type: HELIKA_EVENT_TYPE.UI,
        event: {
          event_sub_type: 'tab_earn_click',
          event_details: {
            event_label: 'App earn tab click',
            event_action: 'click',
          },
        },
      });
    }

    if (tab.path === PAGE.POLLS) {
      analytics.sendEvent({
        event_type: HELIKA_EVENT_TYPE.UI,
        event: {
          event_sub_type: 'tab_polls_click',
          event_details: {
            event_label: 'App earn polls click',
            event_action: 'click',
          },
        },
      });
    }

    if (tab.path === PAGE.TOURNAMENTS) {
      analytics.sendEvent({
        event_type: HELIKA_EVENT_TYPE.UI,
        event: {
          event_sub_type: 'page_tournament_click',
          event_details: {
            event_label: 'Page tournament click',
            event_action: 'click',
          },
        },
      });
    }

    if (tab.path === PAGE.OPINIONS) {
      analytics.sendEvent({
        event_type: HELIKA_EVENT_TYPE.UI,
        event: {
          event_sub_type: 'page_opinion_click',
          event_details: {
            event_label: 'Page opinion click',
            event_action: 'click',
          },
        },
      });
    }

    goTo(tab.path);
  };

  const isTabActive =
    tab.path === '' ? currentPage === '' : currentPage?.includes(tab.path);
  return (
    <button
      onClick={handleSetPage}
      className={cn(styles.tab, isTabActive && styles.activeTab)}
    >
      {tab.tabIcon && <tab.tabIcon />}
      {t(tab.title)}
    </button>
  );
});
